//
// Generated class AdyenPaymentEntity
//

/// <reference path="AdyenPaymentEntity_ManagedObject.ts" />

enum AdyenPaymentEntityCompanyType
{
    individual = 0,
    organization = 1,
    soleProperty = 2,
}

// The onboarding state moved to PaymentEntityStatus: model 63 keeps `status`
// on the base entity, because every payment type answers the same question.


class AdyenPaymentEntity extends AdyenPaymentEntity_ManagedObject
{
    static stringForCompanyType(type:AdyenPaymentEntityCompanyType):string {

        switch (type){
            case AdyenPaymentEntityCompanyType.individual: return MIOLocalizeString("INDIVIDUAL", "INDIVIDUAL");
            case AdyenPaymentEntityCompanyType.organization: return MIOLocalizeString("ORGANIZATION", "ORGANIZATION");
            case AdyenPaymentEntityCompanyType.soleProperty: return MIOLocalizeString("SOLE PROPERTY", "SOLE PROPERTY");
        }        
    }

    static supportedCompanyTypes() : AdyenPaymentEntityCompanyType[] {
        return [
            AdyenPaymentEntityCompanyType.organization,
            AdyenPaymentEntityCompanyType.soleProperty
        ];        
    }
}
